import { useEffect, useMemo } from "react";
import { useProductsTypeProduct } from "../lib/react-query/useProducts";

export const usePreparedProductsForService = (service, { search = "", orderField = "", orderDirection = "", addDefaultProducts } = {}) => {
  const {
    isLoading,
    isFetching,
    data: productsInfiniteData,
  } = useProductsTypeProduct({
    search,
    orderField,
    orderDirection,
    serviceId: service.id,
    onPage: 1000,
    enabled: !!service.has_available_products,
  });

  const products = useMemo(() => {
    const flat = productsInfiniteData?.pages?.flatMap((page) => page) ?? [];

    return flat.map((product) => {
      const selectedProduct = service.products?.find((p) => p.id === product.id);
      const matchedService = product.services?.find((s) => +s.service_id === +service.id);
      const qty = selectedProduct ? selectedProduct.qty : +matchedService?.qty || 0;

      return { ...product, is_available: true, qty };
    });
  }, [productsInfiniteData, service]);

  const totalCount = products.length;

  useEffect(() => {
    if (addDefaultProducts && !service.isProductsInitialized && !isLoading && products.length) {
      addDefaultProducts(service.id, products.filter((p) => p.qty > 0));
    }
  }, [addDefaultProducts, products, isLoading, service.isProductsInitialized, service.id]);

  return {
    products,
    totalCount,
    isLoading: !!service.has_available_products && isLoading,
    isFetching,
  };
};
